import React from 'react';
import { useTranslation } from '@wix/fe-essentials/i18n';
import { Table } from './Table/Table';
import { HeaderLine } from './HeaderLine';
import { BodyCell } from './BodyCell';
import { getTaxColumn } from './TaxColumn';
import s from './GridTable.scss';
export const GridTable = ({ showTaxColumn, formatCurrency: currency, lineItems, }) => {
    const { t } = useTranslation();
    return (React.createElement(Table, { columnGap: showTaxColumn ? '12px' : '18px', columns: [
            {
                header: (React.createElement("div", { className: s.header },
                    React.createElement(HeaderLine, { dataHook: "product-title" }, t('invoice-view:price-quote.view.line-items.product')))),
                value: (item, index) => (React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(BodyCell, { dataHook: `name-${index}`, size: "small", weight: "normal" }, item.name),
                    React.createElement("span", { className: s.descriptionCell, "data-hook": `description-${index}` }, item.description))),
                width: 'minmax(105px, 1fr)',
                printWidth: 'auto',
            },
            {
                header: (React.createElement("div", { className: s.header },
                    React.createElement(HeaderLine, { dataHook: "quantity-title" }, t('invoice-view:price-quote.view.line-items.quantity')))),
                value: (item, index) => (React.createElement(BodyCell, { dataHook: `quantity-${index}` }, item.quantity)),
                width: showTaxColumn ? 'minmax(60px, 88px)' : 'minmax(80px, 110px)',
                printWidth: showTaxColumn ? '60px' : '80px',
            },
            {
                header: (React.createElement("div", { className: s.header },
                    React.createElement(HeaderLine, { dataHook: "price-title" }, t('invoice-view:price-quote.view.line-items.price')))),
                value: (item, index) => (React.createElement(BodyCell, { dataHook: `price-${index}` }, currency(item.price))),
                width: showTaxColumn ? 'minmax(80px, 99px)' : 'minmax(80px, 131px)',
                printWidth: showTaxColumn ? '80px' : '99px',
            },
            ...(showTaxColumn ? [getTaxColumn({ t })] : []),
            {
                header: (React.createElement("div", { className: s.header },
                    React.createElement(HeaderLine, { dataHook: "total-title" }, t('invoice-view:price-quote.view.line-items.total')))),
                value: (item, index) => (React.createElement(BodyCell, { dataHook: `total-${index}` }, currency(item.total))),
                width: showTaxColumn ? 'minmax(80px, 99px)' : 'minmax(80px, 131px)',
                printWidth: showTaxColumn ? '80px' : '99px',
                align: 'end',
            },
        ], items: lineItems }));
};
//# sourceMappingURL=GridTable.js.map